<script setup lang="ts">
import { ref } from 'vue'

withDefaults(defineProps<{
  label: string
  type?: 'button' | 'submit' | 'reset'
  disabled?: boolean
  tone?: 'neutral' | 'success' | 'warning' | 'danger' | 'info' | 'progress'
}>(), { type: 'button' })
const element = ref<HTMLButtonElement>()
defineExpose({ focus: (options?: FocusOptions) => element.value?.focus(options) })
</script>

<template>
  <button ref="element" class="st-icon-button" :class="tone ? ['st-icon-button--tonal', `st-tone-${tone}`] : undefined" :type="type" :aria-label="label" :disabled="disabled">
    <slot />
  </button>
</template>
